import { render, staticRenderFns } from "./FormationGesturePostureComp.vue?vue&type=template&id=17000fd9&scoped=true"
import script from "./FormationGesturePostureComp.vue?vue&type=script&lang=js"
export * from "./FormationGesturePostureComp.vue?vue&type=script&lang=js"
import style0 from "./FormationGesturePostureComp.vue?vue&type=style&index=0&id=17000fd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17000fd9",
  null
  
)

/* custom blocks */
import block0 from "./FormationGesturePostureComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports